import { render, staticRenderFns } from "./EmpresaUpload.vue?vue&type=template&id=f53a5278&scoped=true"
import script from "./EmpresaUpload.vue?vue&type=script&lang=js"
export * from "./EmpresaUpload.vue?vue&type=script&lang=js"
import style0 from "./EmpresaUpload.vue?vue&type=style&index=0&id=f53a5278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53a5278",
  null
  
)

export default component.exports